module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarModal),
      expression: "mostrarModal"
    }, {
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal fade-in",
    style: ({
      zIndex: _vm.updatePlateClicked ? 9999 : 99999
    })
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('h2', [_vm._v("Placa do veículo - Confira as informações")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "labelContainer"
  }, [_c('label', [_vm._v("Formato Antigo")]), _vm._v(" "), _c('label', [_vm._v("Padrão Mercosul")])]), _vm._v(" "), _c('div', {
    staticClass: "plate-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPlate),
      expression: "oldPlate"
    }, {
      name: "only-numbers",
      rawName: "v-only-numbers"
    }],
    staticClass: "input-old",
    attrs: {
      "disabled": "",
      "id": "oldPlate",
      "maxlength": "8"
    },
    domProps: {
      "value": (_vm.oldPlate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPlate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPlate),
      expression: "newPlate"
    }],
    staticClass: "input-new",
    attrs: {
      "disabled": "",
      "autocomplete": "off",
      "id": "newPlate"
    },
    domProps: {
      "value": (_vm.newPlate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPlate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "cancel-button",
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "confirm-button",
    on: {
      "click": function($event) {
        return _vm.doUpdatePlate()
      }
    }
  }, [_vm._v("\n          Confirmar mudança\n        ")])]), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-7866cdb0!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-switch-plate.vue
// module id = 2174
// module chunks = 1